import resumelink from '../assets/resume.pdf'

const Resume = () => {
    
    const submitHandler = async (e) => {
        e.preventDefault()
    }
    return(
        <div className="resume">
            <h2>Resume</h2>
            <button className="button">
            <a href={resumelink} download = "resume.pdf" onSubmit={submitHandler}>
            Download Resume
            </a></button>
        </div>

    )
}

export default Resume 